import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TextDisplayPanel = ({ title, paragraphs, fallbackText, containerClassName = '', paragraphsListClassName = '', virtualizer, }) => {
    const renderContent = () => {
        if (virtualizer && paragraphs && paragraphs.length > 0) {
            return (_jsx("div", { style: {
                    height: `${virtualizer.getTotalSize()}px`,
                    width: '100%',
                    position: 'relative',
                }, children: virtualizer.getVirtualItems().map(virtualItem => {
                    const paragraph = paragraphs[virtualItem.index];
                    if (!paragraph)
                        return null; // Defensive check
                    return (_jsx("div", { ref: virtualizer.measureElement, "data-index": virtualItem.index, id: `paragraph-${paragraph.id}`, className: `${virtualItem.index > 0 ? 'pt-4' : ''} p-2 rounded ${paragraph.className || ''}`, style: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            transform: `translateY(${virtualItem.start}px)`,
                        }, onMouseUp: paragraph.onMouseUp, onTouchEnd: paragraph.onTouchEnd, children: paragraph.children || paragraph.text }, paragraph.id));
                }) }));
        }
        if (paragraphs && paragraphs.length > 0) {
            return (_jsx("div", { className: paragraphsListClassName, children: paragraphs.map((paragraph, index) => (_jsx("div", { id: `paragraph-${paragraph.id}`, className: `${index > 0 ? 'pt-4' : ''} p-2 rounded ${paragraph.className || ''}`, onMouseUp: paragraph.onMouseUp, onTouchEnd: paragraph.onTouchEnd, children: paragraph.children || paragraph.text }, paragraph.id))) }));
        }
        return (_jsx("div", { className: "whitespace-pre-wrap", children: fallbackText || _jsx("span", { className: "text-gray-500 italic", children: "No content available" }) }));
    };
    return (_jsxs("div", { className: containerClassName, children: [title && _jsx("h2", { className: "text-lg font-medium text-gray-900 mb-4", children: title }), renderContent()] }));
};
export default TextDisplayPanel;
//# sourceMappingURL=TextDisplayPanel.js.map